import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import store from '@/store';
import { logoutApi } from '@/api';
import i18n from '@/lang/lang';
import { projectSolarRoutes, projectSolarSiteinfoChildrenRoutes, projectEnergyRoutes, projectSituationRoomRoutes, projectOtherSourcesRoutes } from '../routes';
export function createPermissionGuard(router) {
  router.onError(function (error) {
    var pattern = /Loading chunk (\d)+ failed/g;
    var isChunkLoadFailed = error.message.match(pattern);
    if (isChunkLoadFailed) {
      window.location.reload();
    }
  });
  router.beforeEach(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
      var userDetail, canEnter, _store$state$projects, permissions, now, dataTime, diff, menuNameList, _permissions;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              userDetail = JSON.parse(localStorage.getItem('userDetail')); // tvscreen 不受 auth 權限 或 無 userDetail 影響
              // 僅能從專案進入 不能由網址進入或重整網址
              if (!(to.name === 'tvscreen')) {
                _context.next = 7;
                break;
              }
              canEnter = sessionStorage.getItem('allow-tvscreen');
              if (canEnter) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", next({
                name: 'login'
              }));
            case 5:
              // 通過檢查 → 進入後刪除一次，避免重整再進
              sessionStorage.removeItem('allow-tvscreen');
              return _context.abrupt("return", next());
            case 7:
              if (!(to.name === 'login' && userDetail)) {
                _context.next = 10;
                break;
              }
              _context.next = 10;
              return logoutApi().then(function () {
                localStorage.removeItem('userDetail');
              }).catch(function (err) {
                return console.log('router.beforeEach logoutApi error', err);
              });
            case 10:
              if (!(to.name !== 'login')) {
                _context.next = 19;
                break;
              }
              if (!userDetail) {
                _context.next = 15;
                break;
              }
              store.commit('ADD_USER_DETAIL', userDetail);
              _context.next = 16;
              break;
            case 15:
              return _context.abrupt("return", next({
                name: 'login'
              }));
            case 16:
              if (store.state.roleArray.length) {
                _context.next = 19;
                break;
              }
              _context.next = 19;
              return store.dispatch('getAllGroups');
            case 19:
              if (!(to.name === 'root')) {
                _context.next = 21;
                break;
              }
              return _context.abrupt("return", next({
                name: ((_store$state$projects = store.state.projects[0]) === null || _store$state$projects === void 0 ? void 0 : _store$state$projects.homePageName) || 'Not Found',
                params: {
                  lang: i18n.locale
                }
              }));
            case 21:
              if (!(to.name === 'realtime')) {
                _context.next = 29;
                break;
              }
              permissions = _toConsumableArray(store.state.solarPermissionArray); // 檢查權限
              if (permissions.includes(to.name)) {
                _context.next = 25;
                break;
              }
              return _context.abrupt("return", next({
                name: 'Not Found'
              }));
            case 25:
              if (!store.state.realTimeRePostBeginTime) {
                store.state.realTimeRePostBeginTime = DateTime.local();
              } else {
                now = DateTime.local();
                dataTime = DateTime.fromISO(store.state.realTimeRePostBeginTime, {
                  zone: 'Asia/Taipei'
                });
                diff = now.diff(dataTime, 'minutes').toObject();
                if (diff.minutes >= 5) {
                  store.state.realTimeRePostBeginTime = null;
                  store.state.realTimeDataReload = true;
                }
              }
              return _context.abrupt("return", next());
            case 29:
              // to.name === 其他頁 / Not Found
              // ------ 檢查當前路由的權限 ------
              // 若 to.name 在 menuNameList 中但沒有權限
              menuNameList = [].concat(_toConsumableArray(projectSolarRoutes), _toConsumableArray(projectSolarSiteinfoChildrenRoutes), _toConsumableArray(projectEnergyRoutes), _toConsumableArray(projectSituationRoomRoutes), _toConsumableArray(projectOtherSourcesRoutes)).map(function (item) {
                return item.name;
              });
              _permissions = [].concat(_toConsumableArray(store.state.solarPermissionArray), _toConsumableArray(store.state.roleComponentMenu), _toConsumableArray(store.state.energyPermissionArray), _toConsumableArray(store.state.roomPermissionArray), _toConsumableArray(store.state.otherSourcesPermissionArray)); // 無權限的頁面
              if (!(menuNameList.includes(to.name) && !_permissions.includes(to.name))) {
                _context.next = 33;
                break;
              }
              return _context.abrupt("return", next({
                name: 'Not Found'
              }));
            case 33:
              if (!to.query.siteName) {
                _context.next = 37;
                break;
              }
              if (store.state.factoryInfo.length) {
                _context.next = 37;
                break;
              }
              _context.next = 37;
              return store.dispatch('asyncInfo');
            case 37:
              return _context.abrupt("return", next());
            case 38:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }());
}